function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2,
  filter: "url(#map-marker_svg__filter0_f_41029_4730)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83 77.926c0 5.757-25.6 12.953-32 12.953-6.4 0-32-7.196-32-12.953 0-3.974 14.327-7.195 32-7.195 17.673 0 32 3.221 32 7.195z",
  fill: "#000"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-figma-bg-blur-radius": 56.889
}, /*#__PURE__*/React.createElement("path", {
  d: "M83 32.457C83 58.423 57.4 90.88 51 90.88c-6.4 0-32-32.457-32-58.423C19 14.532 33.327 0 51 0c17.673 0 32 14.532 32 32.457z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51 .593c17.338 0 31.407 14.258 31.407 31.864 0 12.817-6.33 27.308-13.508 38.632-3.582 5.653-7.36 10.489-10.627 13.904-1.636 1.709-3.132 3.05-4.404 3.96-.636.454-1.205.793-1.698 1.017-.499.226-.887.317-1.17.317-.283 0-.671-.091-1.17-.317-.493-.224-1.062-.563-1.698-1.018-1.272-.91-2.768-2.25-4.404-3.959-3.268-3.415-7.044-8.251-10.627-13.904-7.177-11.324-13.508-25.815-13.508-38.632C19.593 14.851 33.663.593 51 .593z",
  stroke: "url(#map-marker_svg__paint0_linear_41029_4730)",
  strokeOpacity: 0.5,
  strokeWidth: 1.185
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 27.296,
  y: 8.219,
  width: 47.407,
  height: 46.948,
  rx: 23.474,
  fill: "#4951EF"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 26.704,
  y: 7.626,
  width: 48.593,
  height: 48.133,
  rx: 24.067,
  stroke: "url(#map-marker_svg__paint1_linear_41029_4730)",
  strokeOpacity: 0.2,
  strokeWidth: 1.185
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "map-marker_svg__paint0_linear_41029_4730",
  x1: 51,
  y1: 0,
  x2: 51,
  y2: 90.88,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.471,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A1A1A1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "map-marker_svg__paint1_linear_41029_4730",
  x1: 51,
  y1: 8.219,
  x2: 51,
  y2: 55.167,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A1A1A1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.529,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "map-marker_svg__bgblur_0_41029_4730_clip_path",
  transform: "translate(37.889 56.889)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M83 32.457C83 58.423 57.4 90.88 51 90.88c-6.4 0-32-32.457-32-58.423C19 14.532 33.327 0 51 0c17.673 0 32 14.532 32 32.457z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "map-marker_svg__filter0_f_41029_4730",
  x: 0.037,
  y: 51.767,
  width: 101.926,
  height: 58.074,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9.481,
  result: "effect1_foregroundBlur_41029_4730"
})));

function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 110,
    viewBox: "0 0 102 110",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default "data:image/svg+xml;base64,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";
export { SvgMapMarker as ReactComponent };